import styled from 'styled-components';
import { device } from 'commons';

export const Wrapper = styled.div`
  display: flex;
  gap: 16px;

  @media (max-width: ${device.desktopSmall}px) {
    flex-direction: column;
  }
`;

export const Card = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 16px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.neutral_200};
  padding: 16px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  min-width: 64px;
  min-height: 64px;
  border-radius: 64px;
  background-color: ${({ theme }) => theme.neutral_100};

  svg {
    width: 32px;
    height: 32px;
  }
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Description = styled.div`
  display: flex;
  gap: 4px;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

export const ValueWrapper = styled.div<{ $negative?: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ $negative, theme }) =>
    $negative ? theme.danger_500 : theme.success_300};
`;
